export default __webpack_public_path__ + "static/media/benefit_11@2x.91d91cd9.png";